import { Component, Input } from '@angular/core';
import { IconService } from 'src/app/shared/services/icon.service';

@Component({
  selector: 'app-student-all-grades-detailed-list-view-block-list',
  templateUrl: './student-all-grades-detailed-list-view-block-list.component.html',
  styleUrls: ['./student-all-grades-detailed-list-view-block-list.component.scss'],
})
export class StudentAllGradesDetailedListViewBlockListComponent {
  blockData: any;
  @Input({ required: true }) generalSettingsData: any;

  constructor(private iconService: IconService) 
  {}
 
  @Input({ required: true }) set data(value: any) {
    if (value) {
      if(value.icon) {
        this.iconService.addIconToRegistry({
          key: value.icon,
          path: value.icon,
        });
      } else {
        value.icon = 'grades';
      } 
      this.blockData = value;
    }
  }
}
